import { useFirebase } from '../../../contexts/FirebaseContext';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { AppContent } from '../AppContent/AppContent';
import { Sidebar } from '../Sidebar/Sidebar';
import { Topbar } from '../Topbar/Topbar';
import styles from './AppShell.module.scss';

const AppShell = ({ children, className = '' }) => {
  const { isLoggedIn } = useFirebase();
  const { isNative } = useCapacitor();
  const showSidebar = isLoggedIn && !isNative;

  return (
    <div className={`${styles.shell} ${className}`}>
      <header><Topbar /></header>
      <div className={`${styles.layout} ${showSidebar ? styles.withSidebar : ''}`}>
        {showSidebar && <aside className={styles.sidebarColumn}><Sidebar /></aside>}
        <main className={styles.content}><AppContent>{children}</AppContent></main>
      </div>
    </div>
  );
};

export { AppShell };
